import React from "react";
import "./HomeSections.css";

const AccoladesPromoElements = (props) => {
  return (
    <div className="col-lg-4 col-md-4 col-12 mt-4" key={props.i}>
      <div className="rc-trust-card">
        <img src={props.d.remote_image} alt="" aria-hidden="true" />
        <div>
          <h3>{props.d.title}</h3>
          <p>{props.d.subtitle}</p>
        </div>
      </div>
    </div>
  );
};

export default AccoladesPromoElements;
